<template>
  <v-app>
    <v-main>
      <v-container class="mt-0">
        <v-row class="d-flex justify-center">
          <v-col lg="4" md="6" sm="8" cols="10">
            <v-img
              alt="Antana Logo"
              class="shrink mx-auto"
              contain
              src="../assets/icon.png"
              transition="scale-transition"
              height="100px"
            />
            <v-card color="primary" dark class="mt-2">
              <v-card-text>
                <v-row class="text-center">
                  <v-col class="mb-n6">
                    <h1 style="color:white">Register</h1>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                   <v-form
                    ref="form"
                    v-model="valid"
                    lazy-validation
                  >
                    <v-text-field
                      v-model="name"
                      :rules="nameRules"
                      label="Name"
                      type="text"
                      prepend-icon="mdi-account"
                      required
                    ></v-text-field>
                    <v-text-field
                      v-model="email"
                      :rules="emailRules"
                      label="E-mail"
                      type="email"
                      prepend-icon="mdi-email"
                      required
                    ></v-text-field>
                    <v-text-field
                      v-model="password"
                      :rules="passwordRules"
                      label="Password"
                      :type="show1 ? 'text' : 'password'"
                      prepend-icon="mdi-lock"
                      :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                      @click:append="show1 = !show1"
                      required
                    ></v-text-field>
                    <v-select
                      v-model="role"
                      :items="roles"
                      :hide-no-data="!search"
                      label="Select a Role"
                      prepend-icon="mdi-badge-account"
                      auto-select-first
                      :rules="roleRequired"
                    >
                    </v-select>
                    <v-select
                      v-model="location"
                      :items="locations"
                      label="UPTD PSDA"
                      prepend-icon="mdi-crosshairs-gps"
                      auto-select-first
                      :rules="locationRequired"
                    >
                    </v-select>
                    <h4 style="color:#ff5252">{{errorServer}}</h4>
                    <br>
                    <router-link :to="{name: 'Login'}">
                    <v-btn
                        text
                        x-small
                      >
                      Already Have An Account?
                    </v-btn>
                    </router-link>

                    <v-btn
                      color="warning"
                      class="float-end"
                      @click="Register(email,password)"
                    >
                      Register
                    </v-btn>
                  </v-form> 
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

         <v-row class="d-flex justify-center">
          <v-col>
            <v-card flat class="my-4">
              <v-row no-gutters class="text-center">
                <v-col>
                  <v-img
                    alt="Dinas Logo"
                    class="shrink float-left"
                    contain
                    src="@/assets/provinsi.png"
                    transition="scale-transition"
                    width="70"
                  />
                  <div class="text-caption">DINAS SUMBER DAYA AIR PROVINSI JAWA BARAT</div>  
                  <div class="text-caption">Jl.Braga No.137, Babakan Ciamis, Kec. Sumur Bandung,</div>
                  <div class="text-caption">Kota Bandung, Jawa Barat 40111 (022) 4236113</div>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import firebase from "firebase/app"
import 'firebase/auth'
import { db }from "../firebase/db.js"

  export default {
    name: 'Register',

    data: () => ({
      show1: false,
      search: null,
      searchLocation:null,
      email:'',
      password:'',
      role:null,
      roles:[],
      location:null,
      locations:['WS CIMANUK - CISANGGARUNG', 'WS CITANDUY', 'WS CIWULAN - CILAKI','WS CISADEA - CIBARENO','WS CITARUM', 'WS CILIWUNG - CISADANE'],
      errorServer:'',
      valid: true,
      name: '',
      nameRules: [
        v => !!v || 'Name is required',
      ],
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
      passwordRules: [
        v => !!v || 'Password is required',
        v => (v && v.length >=8) || 'Password must be at least 8 characters'
      ],
      roleRequired: [
        v => !!v || 'Role is required',
      ],
      locationRequired: [
        v => !!v || 'Location is required',
      ],
    }),
    mounted () {
      db.collection('user').doc('role').onSnapshot((doc) => {
        this.roles=doc.data().roles
      })
      // db.collection('location').doc('locations').onSnapshot((doc) => {
      //   this.locations=doc.data().locations
      // })
      // firebase.auth().onAuthStateChanged((user) => {
      //   if (user) {
      //     //Signed In
      //     var uid = user.uid;
      //     var userRef = db.collection('Users')
      //     userRef.doc(uid).get().then((doc) => {
      //       if (doc.data().role ==='unassigned') {
      //         //UnAssigned
      //         this.$router.push('confirm')
      //       } else {
      //         //Assigned
      //         this.$router.push('/')
      //       }
      //     })
      //   } 
      // });
    },
    methods: {
      Register(email,password) {
        if (this.$refs.form.validate()) {
          let loader=this.$loading.show()
          firebase.auth().createUserWithEmailAndPassword(email, password)
          .then((userCredential) => {
            // Signed in 
            var user = userCredential.user.uid;
            var userRef = db.collection('user')
            userRef.doc(user).set({
              name: this.name,
              role: this.role,
              email: this.email,
              confirmed: false,
              location: this.location
            })
            loader.hide()
            this.$router.push('confirm')
          })
          .catch((error) => {
            // var errorCode = error.code;
            loader.hide()
            this.errorServer = error.message;
          });
        }
      },
      filterItems(arr, query) {
        return arr.filter(function(el) {
          console.log(el)
          return (el.toLowerCase().indexOf(query.toLowerCase()) !== -1)
        })
      }
    },
    watch: {
      // async role (val, prev) {
      //   val = val != null ? val : ''
      //   prev = prev != null ? prev : ''
      //   if (val.length === prev.length) return
      //   if (val!== '') {
      //     if (this.filterItems(this.roles,val).length==0) {
      //       if (val!=null) {
      //         this.roles.push(val)
      //         await db.collection('roleNotification').doc(val).set({
      //           location:false,
      //           notif:['start','stop','notifc','notifa','battery','turnedon']
      //         })
      //       }
      //       var userRef = db.collection('user')
      //       if (this.roles.indexOf(null)===-1) {
      //         await userRef.doc('role').set({
      //           roles:this.roles
      //         })
      //       }
      //     }
      //   }
      // },
      // location (val, prev) {
      //   val = val != null ? val : ''
      //   prev = prev != null ? prev : ''
      //   if (val.length === prev.length) return
      //   if (val!== '') {
      //     if (this.filterItems(this.locations,val).length==0) {
      //       this.locations.push(val)
      //       var locRef = db.collection('location')
      //       console.log(this.locations)
      //       locRef.doc('locations').set({
      //         locations:this.locations
      //       })
      //     }
          
      //   }
      // },
    }
  }
</script>
